module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600italic.5eb91803.svg";